// This file should live somewhere else, maybe in the individual fetch functions when we build them for savings and chequing
export default {
    GIC: 'gic',
    SAVINGS: 'savings',
    CHEQUING: 'chequing',
    ROBO: 'roboadvisor',
};
